const formatVehicleLabel = (vehicle) => `${vehicle.vehicle_id ? `${vehicle.vehicle_id} — ` : ''}${vehicle.license_plate}`

export default formatVehicleLabel
